import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { OfferGroup, ServiceOffersResponse } from '../../../model';

type Props = {
    offerGroup: OfferGroup;
    data: ServiceOffersResponse;
};

export const PlansProductSchema: FC<Props> = ({ offerGroup, data }) => {
    const { t } = useTranslations();

    const namesMap: Record<OfferGroup, string> = {
        MHS: t['plans.plans_list.product_schema.mhs.name'],
        MBB: t['plans.plans_list.product_schema.mbb.name'],
    };
    const descriptionsMap: Record<OfferGroup, string> = {
        MHS: t['plans.plans_list.product_schema.mhs.description'],
        MBB: t['plans.plans_list.product_schema.mbb.description'],
    };

    const offerCount = data?.items.length;
    const allPrices = data?.items.map((item) => item.price);
    const lowPrice = allPrices?.length > 0 ? Math.min(...allPrices) : 0;
    const highPrice = allPrices?.length > 0 ? Math.max(...allPrices) : 0;

    const productSchema = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: namesMap[offerGroup],
        image: t['plans.plans_list.product_schema.image'],
        description: descriptionsMap[offerGroup],
        brand: {
            '@type': 'Brand',
            name: 'Telia',
        },
        offers: {
            '@type': 'AggregateOffer',
            offerCount,
            lowPrice,
            highPrice,
            priceCurrency: 'EUR',
        },
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchema) }} />;
};
